import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ReactDOM from 'react-dom';
import { TABLET_WIDTH } from 'constants/breakPoints';
import { removeAccents } from 'utils/string';
import { getOptions } from '../modules/actions';
import { ResultsModal } from './styles';

function AutocompleteInput(props) {
  const {
    placeholder, options, async, type, literals, onSelectOption, canCreateNew, onCreateOption,
  } = props;
  const [search, setSearch] = useState('');
  const [isFocus, setIsFocus] = useState(false);
  const [results, setResults] = useState(options);
  const [myResultsModal, setMyResultsModal] = useState(null);

  const toSearch = useRef(null);
  const inputEl = useRef(null);

  let searchId = 0;

  const doSearch = () => {
    const newSearchId = Math.round(Math.random() * 99999);
    searchId = newSearchId;
    if (search) {
      getOptions(type, search)
        .then((response) => {
          if (newSearchId === searchId) {
            setResults(response);
          }
        });
    }
  };

  useEffect(() => {
    if (async) {
      doSearch();
    }

    const resultsModal = document.createElement('div');
    resultsModal.setAttribute('id', 'results-modal');
    document.body.appendChild(resultsModal);
    return (() => {
      document.body.removeChild(resultsModal);
    });
  }, []);

  const filterOptions = () => {
    const strToSearch = removeAccents(search.toLowerCase());
    setResults(_.filter(options, (option) => {
      if (!search) {
        return true;
      }

      const label = removeAccents(option.label.toLowerCase());

      return label.indexOf(strToSearch) >= 0;
    }));
  };

  useEffect(() => {
    filterOptions();

    return (() => {
      if (toSearch) {
        clearTimeout(toSearch);
      }
    });
  }, [options, search]);

  const removeResultsModal = () => {
    if (myResultsModal) {
      ReactDOM.unmountComponentAtNode(myResultsModal);
      setMyResultsModal(null);
    }
  };

  useEffect(() => {
    if (!isFocus) {
      removeResultsModal();
    }
  }, [isFocus]);

  useEffect(() => {
    if (async) {
      clearTimeout(toSearch.current);
      toSearch.current = setTimeout(doSearch, 1000);
    }
  }, [search]);

  const handleSearcher = (event) => {
    setSearch(event.currentTarget.value);
  };

  const handleCreate = () => {
    const tagCreated = {
      name: search,
    };

    onCreateOption(tagCreated);
  };

  const handleFocus = () => {
    setIsFocus(true);

    if (async) {
      clearTimeout(toSearch.current);
      toSearch.current = setTimeout(doSearch, 1000);
    } else {
      filterOptions();
    }
  };

  const handleBlur = () => {
    setTimeout(() => {
      setIsFocus(false);
    }, 250);
  };

  const handleSelect = (event) => {
    const { onSelect } = props;
    const add = {
      id: parseInt(event.currentTarget.getAttribute('data-id'), 10),
      name: event.currentTarget.getAttribute('name'),
    };
    onSelectOption(add);
    if (onSelect) {
      onSelect(add);
    }
  };

  const printResults = () => {
    let content = [];
    if (!search) {
      return removeResultsModal();
    }

    const bounds = inputEl.current.getBoundingClientRect();
    const {
      left, top, width, height,
    } = bounds;


    const { hasOptions } = props;

    const newLeft = left;
    const newTop = top + height;

    const styles = {
      left: `${newLeft}px`,
      top: `${newTop}px`,
      width: `${width}px`,
    };


    let filteredResults = results;

    if (!results.length) {
      content.push(<div className='no_results' key='no_results'>{literals.noResults}</div>);
    } else if (hasOptions !== null) {
      filteredResults = results.filter((result, index) => {
        return index > (hasOptions + 1);
      });
    }
    content = _.map(filteredResults, result => (
      <div className='result' data-id={result.value} key={result.value} onClick={handleSelect} name={result.label}>
        {result.label}
      </div>
    ));

    if (canCreateNew && search) {
      content.push((
        <div className='result create' key='create' onClick={handleCreate}>
          {`${literals.create} ${search}`}
        </div>
      ));
    }

    const resultsLayer = (
      <ResultsModal style={styles}>
        {content}
      </ResultsModal>
    );

    const resultsModal = document.getElementById('results-modal');
    if (resultsModal) {
      ReactDOM.render(resultsLayer, resultsModal);
    }

    setMyResultsModal(resultsModal);
    return null;
  };

  useEffect(() => {
    if (isFocus) {
      printResults();
    } else {
      removeResultsModal();
    }
  }, [isFocus, search, results]);

  return (
    <React.Fragment>
      <input className='form_input_stl' type='text' value={search} onFocus={handleFocus} onBlur={handleBlur} onChange={handleSearcher} placeholder={placeholder} ref={inputEl} />
    </React.Fragment>
  );
}


AutocompleteInput.propTypes = {
  literals: PropTypes.object.isRequired,
  type: PropTypes.string, // tag || challenge || action || collective
  placeholder: PropTypes.string,
  selectedOptions: PropTypes.array, // ['red','yellow']
  canCreateNew: PropTypes.bool,
  onSelectOption: PropTypes.func.isRequired,
  onCreateOption: PropTypes.func,
  options: PropTypes.array,
  async: PropTypes.bool,
  hasOptions: PropTypes.number,
  onSelect: PropTypes.func,
};

AutocompleteInput.defaultProps = {
  type: 'tag',
  placeholder: 'Search...',
  selectedOptions: [],
  canCreateNew: false,
  onCreateOption: null,
  options: null,
  async: true,
  hasOptions: null,
  onSelect: null,
};

export default AutocompleteInput;



// WEBPACK FOOTER //
// ./src/components/AutocompleteInput/components/index.jsx